import Header from "./../header/Header.vue";
import Footer from "./../footer/Footer.vue";

export default {
  name: "Contact",
  components: {
    Header,
    Footer
  },
  data() {
    return {};
  },
  created() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
